import {
    Component,
    Input
} from '@angular/core';

@Component({
    selector: 'store-nav',
    templateUrl: 'store-nav.component.html',
    host: { 'class': 'store-nav component' }
})
export class StoreNavComponent {
    // properties
    navMenuIcon: string = 'fas fa-bars';

    // io
    @Input() navListVisible: boolean;
    
    toggleNavList(): void {
        this.navListVisible = !this.navListVisible;
        this.navMenuIcon = this.navListVisible ? 'fas fa-times' : 'fas fa-bars';
    }
}



// WEBPACK FOOTER //
// ./client-src/app/eStore/components/store-nav/store-nav.component.ts